export default "__VITE_ASSET__zQM4sJiY__"